import React from 'react';
import { Button } from '@/components/ui';
import { ProfileApiResponse } from '@/lib/api/services/admin-user';
import { Trash2 } from 'lucide-react';

type AdminUser = ProfileApiResponse[0];

interface DeleteUserModalProps {
  isOpen: boolean;
  member: AdminUser;
  onClose: () => void;
  onConfirm: () => void;
  isProcessing?: boolean;
}

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  isOpen,
  member,
  onClose,
  onConfirm,
  isProcessing = false,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Delete user confirmation"
    >
      <div className="bg-white rounded-xl shadow-lg w-full max-w-lg m-4" onClick={(e) => e.stopPropagation()}>
        <div className="p-8 text-center">
          <div className="mx-auto mb-4 w-20 h-20 flex items-center justify-center">
            <div className="w-20 h-20 rounded-full flex items-center justify-center bg-red-100">
            
              <Trash2 className="absolute w-10 h-10 text-red-600" />
            </div>
          </div>

          <h2 className="text-2xl font-bold text-gray-800">Delete User?</h2>
          <p className="text-sm text-gray-500 mt-2 max-w-sm mx-auto">
            Are you sure you want to delete {member.firstName} {member.lastName}?
          </p>
          <p className="text-sm text-gray-500 mt-1 max-w-sm mx-auto">This action cannot be undone.</p>

          <div className="flex justify-center gap-4 mt-8">
            <Button variant="danger" onClick={onConfirm} disabled={isProcessing}>
              {isProcessing ? 'Deleting...' : 'Delete User'}
            </Button>
            <Button variant="secondary" onClick={onClose} disabled={isProcessing}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteUserModal;
